import { configureStore } from "@reduxjs/toolkit";
import userSliceReducer from "../store/userSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";


const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, userSliceReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);